import React from 'react';
import { connect } from 'redux-bundler-react';
import BasemapItem from './basemap-switcher-list-item';

class BasemapList extends React.Component {
  render(){
    const { activeBasemapIdx, basemapList } = this.props;
    return (
      <div className="">
        <ul className="list-group sidebar-list thin-scrollbar">
          {
            basemapList.map((basemap, i) => {
              const active = activeBasemapIdx === i;
              return <BasemapItem active={active} basemap={basemap} key={i} idx={i} />
            })
          }
        </ul>
      </div>
    )
  }
}

export default connect(
  'selectActiveBasemapIdx',
  'selectBasemapList',
  BasemapList
);